// extracted by css-extract-rspack-plugin
export default {"tabBar":"CGhvP","addTabButton":"PKzgZ"};